import React, { Component } from "react";
import { AssessmentTesting } from "../../components/Assessment";
import firebase from "firebase";
import { db } from "../../config/firebaseconfig";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as assessmentActionCreators from "../../redux/modules/assessment";
import * as manageEducatorsActionCreators from "../../redux/modules/manageEducators";
import timestamper from "../../helpers/timestamper";
import forOwn from "mout/object/forOwn";
import testCompleteQ from "../../helpers/assessment/testCompleteQ";
import computeByTestScore from "../../helpers/assessment/computeByTestScore";
import has from "mout/object/has";
import updateGroupUAs from "../../helpers/assessment/updateGroupUAs";
import teacherUser from "../../helpers/users/testing/teacherUser";
import studentUser from "../../helpers/users/testing/studentUser";
import districtAdmin from "../../helpers/users/testing/districtAdmin";
import fetchGroupUAsPromise from "../../helpers/assessment/fetchGroupUAsPromise";
import fetchAllItems from "../../helpers/assessment/fetchAllItems";
import fetchAllPassages from "../../helpers/assessment/fetchAllPassages";
import fetchAllNodes from "../../helpers/assessment/fetchAllNodes";
import initializeManageEducators from "../../helpers/users/initializeManageEducators";
import getGroupType from "../../helpers/assessment/getGroupType";
import computeGroupUA from "../../helpers/assessment/computeGroupUA";
import logStartTest from "../../helpers/users/logStartTest";
import logCompleteTest from "../../helpers/users/logCompleteTest";
import getSchoolYear from '../../helpers/getSchoolYear'
import requestGroupUAUpdate from "../../helpers/assessment/requestGroupUAUpdate";
import updateAllGroupUAsWithStudent from "../../helpers/assessment/updateAllGroupUAsWithStudent";
import markGUAsAsNeedingUpdate from "../../helpers/assessment/markGUAsAsNeedingUpdate";
import guaNeedsUpdateQ from "../../helpers/assessment/guaNeedsUpdateQ";
import processGroupUAUpdate from "../../helpers/assessment/processGroupUAUpdate";
import isLicenseExpired from '../../helpers/users/licenses/isLicenseExpired'
import {BeatLoader} from "react-spinners";
import isLicensed from "../../helpers/users/licenses/isLicensed";
import LicenseDenied from '../../components/Users/Licenses/LicenseDenied';
import schoolYearDataIndicator from '../../helpers/schoolYearDataIndicator';
import { setIndicator } from '../../redux/modules/assessmentIndicator'

const queryString = require("query-string");
const uuid = require("uuid/v1");

class AssessmentTestingContainer extends Component {
  constructor(props) {
    super(props);

    // eventually replace with pulling from the user object in store
    this.state = {
      userId: "67e46760-4193-11e8-b77a-099025fc2489",
      timeRemaining: 0,
      user: teacherUser,
      updatingGUA: false,
      isCompare : false
      // user: studentUser,
      //      user: districtAdmin,
    };

    this.handleSubmitActivity = this.handleSubmitActivity.bind(this);
    this.handleSubmitSubtest = this.handleSubmitSubtest.bind(this);
    this.handleQuickNav = this.handleQuickNav.bind(this);
    this.openTest = this.openTest.bind(this);
    this.selectGroupUA = this.selectGroupUA.bind(this);
    this.selectStudent = this.selectStudent.bind(this);
    this.navTo = this.navTo.bind(this);
    this.toggleAnswerExpiredModal = this.toggleAnswerExpiredModal.bind(this)
  }

  navTo(location) {
    this.props.history.push(location);
  }

  initTestSelector(assessmentId, selectedStudent, selectedGroupUA){
    const { groupUAs, students, userLicenses } = this.props;
    const testId = queryString.parse(this.props.location.search).a
    const actions = {
      setIndicator: this.props.setIndicator
    }
    schoolYearDataIndicator(
      assessmentId, 
      selectedStudent, 
      selectedGroupUA,
      actions, 
      groupUAs, 
      students, 
      userLicenses, 
      testId
      )
  }

  selectStudent(studentId) {
    const groupUAId = this.props.match.params.userAssessmentId;
    const subtestId = this.props.match.params.subTestSetId;
    const qs = queryString.parse(this.props.location.search);
    const assessmentId = qs.a;
    const newQS = {
      ...qs,
      s: studentId
    };
    const query = queryString.stringify(newQS);
    this.props.history.push(
      `/assessment/testing/${groupUAId}/${subtestId}?${query}`
    );

    this.getUserAssessment(studentId, assessmentId);
    this.initTestSelector(null, studentId)
  }

  getUserAssessment(studentId, assessmentId, year) {
    let schoolYear = year ? year : getSchoolYear().year;
    if (!studentId || !assessmentId) return
    this.props.assessmentInitialize();
    db.collection("students")
      .doc(studentId)
      .get()
      .then(doc => {
        const student = doc.data();

        if (has(student, `assessments.${assessmentId}`)) {
            
          let userAssessmentId; 

          if(student.assessments[assessmentId].hasOwnProperty(schoolYear)) {

            userAssessmentId = student.assessments[assessmentId][schoolYear].userAssessmentId;

          } else {
            //for old db structure
            userAssessmentId = student.assessments[assessmentId].userAssessmentId;
          }
          
          if (userAssessmentId) {
            return db
              .collection("userAssessments")
              .doc(userAssessmentId)
              .get();
          } else {
            throw Error("Student userAssessment not found");
          }
        } else {
          throw Error("Student userAssessment not found");
        }
      })
      .then(doc => {
        const userAssessment = doc.data();
        this.props.assessmentInitializeSuccess(userAssessment);
      })
      .catch(err => this.props.assessmentInitializeError(err));
  }

  selectGroupUA(groupUA, itemNumber) {
    const assessmentId = queryString.parse(this.props.location.search).a;
    const subtest = this.props.match.params.subTestSetId;
    let year = queryString.parse(this.props.location.search).y 
    let itemQuery = `item=overview`;
    let nodeQuery = ``;
    if (itemNumber) {
      itemQuery = `item=${itemNumber}`;
    }
    const node = queryString.parse(this.props.location.search).nd;
    if (node !== "" && node !== undefined) {
      nodeQuery = `&&nd=${node}`;
    }
    // const { districts, schools, educators, classes, selectedYear } = this.props;
    // if (districts && schools && educators && classes) {
    //   const groupData = { districts, schools, educators, classes };
    //   const groupType = getGroupType(groupUA, groupData);
    //   const year = selectedYear ? selectedYear : getSchoolYear().year;
    //   computeGroupUA(groupUA, groupType, groupData, assessmentId, year);

    const { districts, schools, educators, classes, fetchingGroupUAsSuccess, groupUAs } = this.props;
    if (districts && schools && educators && classes) {
      const groupData = { districts, schools, educators, classes };
      const groupType = getGroupType(groupUA, groupData);
      year = year ? year : getSchoolYear().year
      if (groupUAs) {
        let groupUAObj
        if (groupUAs[groupUA] && groupUAs[groupUA][year]) {
          groupUAObj = groupUAs[groupUA][year][assessmentId]
          this.initTestSelector(null, null, groupUA)
        }
        if (guaNeedsUpdateQ(groupUAObj) || !groupUAObj) {
          this.setState({updatingGUA: true})
          let schoolYear = Number(year.split('sy')[1])
          requestGroupUAUpdate(groupUA, assessmentId, schoolYear)
            .then(result => {
              // let GUAs = groupUAs
              // if (result) {
              //   const GUA = JSON.parse(result)
              //   GUAs = {
              //     ...groupUAs,
              //     [groupUA]: GUA,
              //   }   
              // }
              // this.setState({updatingGUA: false})
              // fetchingGroupUAsSuccess(GUAs)
              const actions = {
                fetchingGroupUAsSuccess,
                updateState: this.setState.bind(this)
              }
              processGroupUAUpdate(result, groupUAs, groupUA, schoolYear, assessmentId, actions)
            })
            .catch(err => {
              this.setState({updatingGUA: false})
              console.log(err)
            })
        }
      }

      // computeGroupUA(groupUA, groupType, groupData, assessmentId, year, fetchingGroupUAsSuccess, groupUAs);
    }

    this.props.history.push(
      `/assessment/testing/${groupUA}/${subtest}?g=true&a=${assessmentId}&${itemQuery}${nodeQuery}`
    );
  }

  initGroupUA(groupUA) {
    const testUser = this.props.user || this.state.user;

    this.props.assessmentInitialize();
    const qs = queryString.parse(this.props.location.search);
    const selectedGroupUA = this.props.match.params.userAssessmentId;
    const subtestId = this.props.match.params.subTestSetId;
    const studentId = qs.s;
    const assessmentId = qs.a;
    const item = qs.item;

    // get the groupUAs if don't have them already
    const actions = {
      fetching: this.props.fetchingGroupUAs,
      success: this.props.fetchingGroupUAsSuccess,
      error: this.props.fetchingGroupUAsError,
      push: this.props.history.push
    };
    if (!this.props.groupUAs) {
      fetchGroupUAsPromise(
        testUser,
        assessmentId,
        actions,
        selectedGroupUA
      ).catch(err => console.log(err));
    }

    // get items and passages if don't have them already
    if (!this.props.items) {
      fetchAllItems(
        this.props.fetchingAllItems,
        this.props.fetchingAllItemsSuccess,
        this.props.fetchingAllItemsError
      );
    }

    if (!this.props.passages) {
      fetchAllPassages(
        this.props.fetchingAllPassages,
        this.props.fetchingAllPassagesSuccess,
        this.props.fetchingAllPassagesError
      );
    }

    // get nodes if don't have them already
    if (!this.props.nodes) {
      fetchAllNodes(
        this.props.fetchingNodes,
        this.props.fetchingNodesSuccess,
        this.props.fetchingNodesError
      );
    }

    // get the district->student data if we don't have them
    const dataCheck =
      this.props.districts &&
      this.props.schools &&
      this.props.educators &&
      this.props.students &&
      this.props.classes;
    if (!dataCheck && testUser.role !== "Student") {
      const initActions = {
        initializing: this.props.initializing,
        initializingError: this.props.initializingError,
        initializingSuccess: this.props.initializingSuccess,
        set: {
          districts: this.props.setDistricts,
          schools: this.props.setSchools,
          educators: this.props.setEducators,
          students: this.props.setStudents,
          classes: this.props.setClasses
        }
      };
      initializeManageEducators(testUser, initActions);
    }

    if (studentId) {
      this.selectStudent(studentId);
    }
  }

  handleKeyPress(e) {
    if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
      e.preventDefault();
    }
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyPress, false)
    this.props.assessmentInitialize();
    if (!this.props.nodes) {
      fetchAllNodes(
        this.props.fetchingNodes,
        this.props.fetchingNodesSuccess,
        this.props.fetchingNodesError
      );
    }
    const qs = queryString.parse(this.props.location.search);
    if (!qs.g /*|| qs.item !== 'overview'*/) {
      this.unsubscribe = db
        .collection("userAssessments")
        .doc(this.props.match.params.userAssessmentId)
        .onSnapshot(
          doc => {
            if (!doc.exists) {
              this.props.history.push("/assessment/not-found");
            } else {
              !this.props.userAssessment
                ? this.props.assessmentInitializeSuccess(doc.data())
                : this.props.setUserAssessment(doc.data());
            }
          },
          err => this.props.assessmentInitializeError(err)
        );

      //get the active item
      if (this.props.inTest && this.props.userAssessment) {
        let itemNumber = 1;
        if (this.props.location.search) {
          itemNumber = queryString.parse(this.props.location.search).item;
        }
        const subtestId = this.props.match.params.subTestSetId;
        const activeItemId = this.props.userAssessment.destructuredSubtests[
          subtestId
        ].items[itemNumber - 1];
        this.props.fetchingActiveItem();
        activeItemId && db.collection("contentItems")
          .doc(activeItemId)
          .get()
          .then(doc => {
            if (doc.exists) {
              let activeItem = doc.data();
              if (activeItem.passageId && !activeItem.passage) {
                db.collection("contentItemPassages")
                  .doc(activeItem.passageId)
                  .get()
                  .then(passageDoc => {
                    if (passageDoc.exists) {
                      activeItem.passage = passageDoc.data().text;
                      this.props.fetchingActiveItemSuccess(activeItem);
                    } else {
                      this.props.fetchingActiveItemSuccess(activeItem);
                    }
                  })
                  .catch(err => this.props.fetchingActiveItemError(err));
              } else {
                this.props.fetchingActiveItemSuccess(activeItem);
              }
            }
          })
          .catch(err => this.props.fetchingActiveItemError(err));
      }

      this.props.fetchingAllItems();
      db.collection("contentItems")
        .get()
        .then(querySnapshot => {
          let items = {};
          querySnapshot.forEach(doc => {
            const item = doc.data();
            items[item.itemId] = item;
          });
          this.props.fetchingAllItemsSuccess(items);
        })
        .catch(err => this.props.fetchingAllItemsError(err));

      this.props.fetchingAllPassages();
      db.collection("contentItemPassages")
        .get()
        .then(querySnapshot => {
          let passages = {};
          querySnapshot.forEach(doc => {
            const passage = doc.data();
            passages[doc.id] = passage;
          });
          this.props.fetchingAllPassagesSuccess(passages);
        })
        .catch(err => this.props.fetchingAllPassagesError(err));
    } else {
      this.initGroupUA();
    }
    this.props.userAssessment &&
    this.props.AssessmentHeaderDetails(this.props.userAssessment.assessmentSubtests[this.props.match.params.subTestSetId].displayName, this.props.match.params.subTestSetId);
  }

  validateGroupUA(nextProps) {
    // const { districts, schools, educators, classes, selectedYear } = this.props;
    const { districts, schools, educators, classes, fetchingGroupUAsSuccess, groupUAs } = this.props;
    const n = nextProps;
    const thisCheck = !!districts && !!schools && !!educators && !!classes;
    const nextCheck =
      !!n.districts && !!n.schools && !!n.educators && !!n.classes;
    if (thisCheck !== nextCheck && nextCheck) {
      const qs = queryString.parse(n.location.search);
      const groupUA = this.props.match.params.userAssessmentId;
      if (groupUA && qs.g) {
        const groupData = {
          districts: n.districts,
          schools: n.schools,
          educators: n.educators,
          classes: n.classes
        };
        const groupType = getGroupType(groupUA, groupData);
        // const year = selectedYear ? selectedYear : getSchoolYear().year;
        // const assessmentId = qs.a;
        // computeGroupUA(groupUA, groupType, groupData, assessmentId, year);
        const year = qs.y ? qs.y : getSchoolYear().year
        const assessmentId = qs.a
        if (groupUAs) {
          
          let groupUAObj
          if (groupUAs[groupUA] && groupUAs[groupUA][year]) {
            groupUAObj = groupUAs[groupUA][year][assessmentId]
          }
          if (guaNeedsUpdateQ(groupUAObj) || !groupUAObj) {
          this.setState({updatingGUA: true})
          let schoolYear = Number(year.split('sy')[1])
          requestGroupUAUpdate(groupUA, assessmentId, schoolYear)
            .then(result => {
              // let GUAs = groupUAs
              // if (result) {
              //   const GUA = JSON.parse(result)
              //   GUAs = {
              //     ...groupUAs,
              //     [groupUA]: GUA,
              //   }   
              // }
              // this.setState({updatingGUA: false})
              // fetchingGroupUAsSuccess(GUAs)
              const actions = {
                fetchingGroupUAsSuccess,
                updateState: this.setState.bind(this)
              }
              processGroupUAUpdate(result, groupUAs, groupUA, schoolYear, assessmentId, actions)
            })
            .catch(err => {
              this.setState({updatingGUA: false})
              console.log(err)
            })
          }
        }
        // computeGroupUA(groupUA, groupType, groupData, assessmentId, year, fetchingGroupUAsSuccess, groupUAs);
      }
    }
  }

    // componentWillReceiveProps(nextProps) {
  //   // if the search query is different, get the new item
  //   if (this.props.location.search !== nextProps.location.search ||
  //     (!this.props.inTest && nextProps.inTest)  ||
  //     (!this.props.userAssessment && nextProps.userAssessment)) {

  //     // if item number not specified in query, item number is 1
  //     let itemNumber = 1
  //     if (nextProps.location.search) {
  //       itemNumber = queryString.parse(nextProps.location.search).item
  //     }

  //     const subtestId = nextProps.match.params.subTestSetId
  //     let activeItemId

  //     if (nextProps.userAssessment) {
  //       if (nextProps.userAssessment.destructuredSubtests[subtestId]) {
  //         itemNumber = itemNumber || 1
  //         activeItemId = nextProps.userAssessment.destructuredSubtests[subtestId].items[itemNumber - 1]
  //       } else this.props.history.push('/assessment/not-found')
  //     }

  //     // pulls up active item, only pulls from db if don't have items/passages already
  //     if (this.props.items) {
  //       nextProps.fetchingActiveItem()
  //       if (this.props.items[activeItemId]) {
  //         let activeItem = this.props.items[activeItemId]
  //         if ((!activeItem.passageId && !activeItem.passage) || (activeItem.passage)) {
  //           nextProps.fetchingActiveItemSuccess(activeItem)
  //         } else if (has(this.props, `passages.${activeItem.passageId}`)) {
  //           activeItem.passage = this.props.passages[activeItem.passageId].text
  //           nextProps.fetchingActiveItemSuccess(activeItem)
  //         } else {
  //           db.collection('contentItemPassages').doc(activeItem.passageId).get()
  //           .then((passageDoc) => {
  //             if (passageDoc.exists) {
  //               activeItem.passage = passageDoc.data().text
  //               this.props.fetchingActiveItemSuccess(activeItem)
  //             } else {
  //               this.props.fetchingActiveItemSuccess(activeItem)
  //             }
  //           })
  //           .catch((err) => this.props.fetchingActiveItemError(err))
  //         }
  //       }
  //     } else if (activeItemId) {
  //       nextProps.fetchingActiveItem()
  //       db.collection('contentItems').doc(activeItemId).get()
  //       .then((doc) => {
  //         if (doc.exists) {
  //           let activeItem = doc.data()
  //           if (activeItem.passageId && !activeItem.passage) {
  //             // only pull passage from db if it changes
  //             db.collection('contentItemPassages').doc(activeItem.passageId).get()
  //               .then((passageDoc) => {
  //                 if (passageDoc.exists) {
  //                   activeItem.passage = passageDoc.data().text
  //                   this.props.fetchingActiveItemSuccess(activeItem)
  //                 } else {
  //                   this.props.fetchingActiveItemSuccess(activeItem)
  //                 }
  //               })
  //               .catch((err) => this.props.fetchingActiveItemError(err))
  //           } else {
  //             this.props.fetchingActiveItemSuccess(activeItem)
  //           }
  //         }
  //       })
  //       .catch((err) => nextProps.fetchingActiveItemError(err))
  //     }
  //   }
  //   this.validateGroupUA(nextProps)
  // }

  componentDidUpdate(prevProps) {
    // if the search query is different, get the new item
    
    this.props.match.params.subTestSetId !== prevProps.match.params.subTestSetId && this.props.userAssessment &&this.props.userAssessment.assessmentSubtests!==null &&
    this.props.AssessmentHeaderDetails(this.props.userAssessment && this.props.userAssessment.assessmentSubtests[this.props.match.params.subTestSetId].displayName, this.props.match.params.subTestSetId);
 
    if (
      prevProps.location.search !== this.props.location.search ||
      (!prevProps.inTest && this.props.inTest) ||
      (!prevProps.userAssessment && this.props.userAssessment)
    ) {
      // if item number not specified in query, item number is 1
      let itemNumber = 1;
      if (this.props.location.search) {
        itemNumber = queryString.parse(this.props.location.search).item;
      }
     
      const subtestId = this.props.match.params.subTestSetId;
      let activeItemId;

      if (this.props.userAssessment) {


        if (this.props.userAssessment.destructuredSubtests[subtestId]) {
          itemNumber = itemNumber || 1;
          activeItemId = this.props.userAssessment.destructuredSubtests[
            subtestId
          ].items[itemNumber - 1];
        } else prevProps.history.push("/assessment/not-found");
      }

      // pulls up active item, only pulls from db if don't have items/passages already
      if (prevProps.items) {
        this.props.fetchingActiveItem();
        if (prevProps.items[activeItemId]) {
          let activeItem = prevProps.items[activeItemId];
          if (
            (!activeItem.passageId && !activeItem.passage) ||
            activeItem.passage
          ) {
            this.props.fetchingActiveItemSuccess(activeItem);
          } else if (has(prevProps, `passages.${activeItem.passageId}`)) {
            activeItem.passage = prevProps.passages[activeItem.passageId].text;
            this.props.fetchingActiveItemSuccess(activeItem);
          } else {
            db.collection("contentItemPassages")
              .doc(activeItem.passageId)
              .get()
              .then(passageDoc => {
                if (passageDoc.exists) {
                  activeItem.passage = passageDoc.data().text;
                  prevProps.fetchingActiveItemSuccess(activeItem);
                } else {
                  prevProps.fetchingActiveItemSuccess(activeItem);
                }
              })
              .catch(err => prevProps.fetchingActiveItemError(err));
          }
        }
      } else if (activeItemId) {
        this.props.fetchingActiveItem();
        db.collection("contentItems")
          .doc(activeItemId)
          .get()
          .then(doc => {
            if (doc.exists) {
              let activeItem = doc.data();
              if (activeItem.passageId && !activeItem.passage) {
                // only pull passage from db if it changes
                db.collection("contentItemPassages")
                  .doc(activeItem.passageId)
                  .get()
                  .then(passageDoc => {
                    if (passageDoc.exists) {
                      activeItem.passage = passageDoc.data().text;
                      prevProps.fetchingActiveItemSuccess(activeItem);
                    } else {
                      prevProps.fetchingActiveItemSuccess(activeItem);
                    }
                  })
                  .catch(err => prevProps.fetchingActiveItemError(err));
              } else {
                prevProps.fetchingActiveItemSuccess(activeItem);
              }
            }
          })
          .catch(err => this.props.fetchingActiveItemError(err));
      }
    }
    this.validateGroupUA(this.props);

    const { assessmentIndicator, location, user } = this.props;
    const { selectedOption } = assessmentIndicator;

    if (prevProps.assessmentIndicator.selectedOption !== selectedOption) {
      if (selectedOption) {
        const { year, userAssessmentId, gua, student, testId } = selectedOption;
        const qs = queryString.parse(location.search);

        if(has(qs, 's')){
          this.getUserAssessment(student, testId, year)
        } 
        if(user && has(user, 'role') && user.role === 'Student') {
          this.getUserAssessment(student, testId, year)
        }
      }
    }

  }

  createActivity(response) {
    const activityId = uuid();
    return {
      userId: this.state.userId,
      verb: "answered",
      activityId,
      userAssessmentId: this.props.userAssessment.userAssessmentId,
      subTestId: this.props.match.params.subTestSetId,
      itemId: this.props.activeItem.itemId,
      response: response,
      timestamp: timestamper(),
      correct: !!(response && this.props.activeItem.answers[response].correct),
      grade: response && this.props.activeItem.answers[response].correct ? 1 : 0
    };
  }

  // eventually store in collection activities by userId->activityId. Don't worry about this for now.
  // store in userAssessments.activity[subtTestId] by activityId
  // and also answer in userAssessment.answers[subTestId] by itemId
  handleSubmitActivity(response, timeRemaining) {
   if(!isLicenseExpired(this.props.user.role, this.props.userAssessment.assessmentSetId, this.props.userLicenses))
    { const newActivity = this.createActivity(response);
    const userId = this.state.userId;
    const userAssessmentId = this.props.userAssessment.userAssessmentId;
    const subTestId = this.props.match.params.subTestSetId;
    const itemId = this.props.activeItem.itemId;

    const uA = this.props.userAssessment;

    let userAssessment = {
      ...uA,
      activity: {
        ...uA.activity,
        [subTestId]: {
          ...uA.activity[subTestId],
          [newActivity.activityId]: newActivity
        }
      },
      scoring: {
        ...uA.scoring,
        byItem: {
          ...uA.scoring.byItem,
          [subTestId]: {
            ...uA.scoring.byItem[subTestId],
            [itemId]: {
              ...uA.scoring.byItem[subTestId][itemId],
              complete: newActivity.response ? true : false,
              raw: newActivity.grade,
              lastModified: newActivity.timestamp
            }
          }
        }
      },
      destructuredSubtests: {
        ...uA.destructuredSubtests,
        [subTestId]: {
          ...uA.destructuredSubtests[subTestId],
          timeRemaining: 1 // Eventually sync up with clock!!!
        }
      }
    };

    if (userAssessment.answersByItem) {
      userAssessment.answersByItem = {
        ...userAssessment.answersByItem,
        [subTestId]: {
          ...userAssessment.answersByItem[subTestId],
          [newActivity.itemId]: newActivity.response
        }
      };
    } else {
      userAssessment.answersByItem = {
        [subTestId]: {
          [newActivity.itemId]: newActivity.response
        }
      };
    }
    if (response === "") {
      delete userAssessment.answersByItem[subTestId][newActivity.itemId];
    }

    db.collection("userAssessments")
      .doc(userAssessmentId)
      .set(userAssessment)
      .catch(err => console.log(err));

    const path = `destructuredSubtests.${subTestId}.timeRemaining`;
    db.collection("userAssessments")
      .doc(userAssessmentId)
      .update({
        [path]: this.state.timeRemaining
      });}
      else {
        this.toggleAnswerExpiredModal()
      }
  }

  handleSubmitSubtest(trigger) {
    console.log('handleSubmitSubtest')
    let contentItems = {};

    const userAssessmentId = this.props.userAssessment.userAssessmentId;
    const subTestId = this.props.match.params.subTestSetId;
    const complete = `destructuredSubtests.${subTestId}.complete`;
    const timeRemaining = `destructuredSubtests.${subTestId}.timeRemaining`;
    const bySubtestKey = `scoring.bySubtest.${subTestId}`;

    const uA = this.props.userAssessment;
    let subTestRaw = 0;
    const subTestPossible = parseInt(uA.scoring.bySubtest[subTestId].possible);
    forOwn(uA.scoring.byItem[subTestId], (val, key, o) => {
      subTestRaw += parseInt(val.raw);
    });
    let subTestScale = 0;
    if (uA.assessmentSubtests[subTestId].rawToScaleScoring) {
      subTestScale = parseInt(
        uA.assessmentSubtests[subTestId].rawToScaleScoring[subTestRaw],
        10
      );
    }

    const bySubtestData = {
      complete: true,
      percentage: subTestRaw / subTestPossible,
      possible: subTestPossible,
      raw: subTestRaw,
      scale: subTestScale
    };

    let newByNodeScore = Object.assign({}, uA.scoring.byNode[subTestId]);
    forOwn(uA.scoring.byNode[subTestId], (val, key, o) => {
      newByNodeScore[key].raw = 0;
      val.items.forEach(item => {
        newByNodeScore[key].raw =
          parseInt(uA.scoring.byItem[subTestId][item].raw) +
          parseInt(newByNodeScore[key].raw);
        newByNodeScore[key].percentage =
          newByNodeScore[key].raw / newByNodeScore[key].possible;
      });
    });
    const byNodeScoreKey = `scoring.byNode.${subTestId}`;

    const byTestKey = "scoring.byTest";
    let byTestData = Object.assign({}, uA.scoring.byTest);

    if (testCompleteQ(subTestId, uA.destructuredSubtests)) {
      byTestData = computeByTestScore(
        subTestId,
        bySubtestData,
        uA.scoring.bySubtest
      );
    }
    clearInterval(this.countdown)
    db.collection("userAssessments")
      .doc(userAssessmentId)
      .update({
        [complete]: true,
        [timeRemaining]: 0,
        [bySubtestKey]: bySubtestData,
        [byNodeScoreKey]: newByNodeScore,
        [byTestKey]: byTestData
      })
      .catch(err => console.log(err));

    // update groupUAs
    const student = this.props.user || studentUser;
    let year = queryString.parse(this.props.location.search).y

    year = year ? year : getSchoolYear().year

    let schoolYear = Number(year.split('sy')[1])

    updateGroupUAs(
      student,
      subTestId,
      bySubtestData,
      newByNodeScore,
      uA.scoring.byItem[subTestId],
      year,
      uA.assessmentSetId,
      byTestData,
      uA.assessmentSubtests,
      uA.assessmentSet,
      uA.destructuredSubtests,
      uA.answersByItem
    ).then(() => {
      
      return markGUAsAsNeedingUpdate(student, uA.assessmentSetId, schoolYear)
    })
    .then(() => {
      return updateAllGroupUAsWithStudent(student, uA.assessmentSetId, schoolYear)
    })
    .catch(err => console.log(err));

    const user = this.props.user || studentUser;
    logCompleteTest(subTestId, user.id);

    if (trigger === "timeout") {
      this.props.history.push("?item=results&timeout=true");
    }
  }

  handleQuickNav(e) {
    if (e.target.value) {
      this.props.history.push(`?item=${e.target.value}`);
    }
  }

  startTimer() {
    if (!isLicenseExpired(this.props.user.role, this.props.userAssessment.assessmentSetId, this.props.userLicenses)) {
      this.countdown = setInterval(() => {
        let timeRemaining = this.state.timeRemaining - 1000;
        if (timeRemaining <= 0) {
          timeRemaining = 0;
          this.handleSubmitSubtest("timeout");
        }
        this.setState({
          timeRemaining,
        });
        this.props.updateTimeRemaining(this.state.timeRemaining);

        if (timeRemaining === 0) {
          clearInterval(this.countdown);
        }
      }, 1000);
    }
  }

  openTest() {
    if (this.props.userAssessment) {
      const subtestId = this.props.match.params.subTestSetId;
      const destructuredSubtest = this.props.userAssessment
        .destructuredSubtests[subtestId];

      if (!destructuredSubtest.timeRemaining) {
        const subtest = this.props.userAssessment.assessmentSubtests[subtestId];
        const initialTime = subtest.timeLimit * 60 * 1000;
        const userAssessmentId = this.props.match.params.userAssessmentId;
        const path = `destructuredSubtests.${subtestId}.timeRemaining`;
        const user = this.props.user || studentUser;
        logStartTest(subtestId, user.id);
        db.collection("userAssessments")
          .doc(userAssessmentId)
          .update({
            [path]: initialTime
          })
          .then(() => {
            this.setState(
              {
                timeRemaining: initialTime
              },
              () => {
                this.startTimer();
                this.props.setInTest(true);
              }
            );
          })
          .catch(err =>
            console.log("openTest Error AssessmentTestingContainer: ", err)
          );
      } else {
        this.setState(
          {
            timeRemaining: destructuredSubtest.timeRemaining
          },
          () => {
            this.startTimer();
            this.props.setInTest(true);
          }
        );
      }
    }
  }
  componentWillReceiveProps(nextProps){
    let isCompare ;
      isCompare = nextProps.state.assessment.isCompare
    console.log("isComapreatwillreciveprops",isCompare)
    this.setState({isCompare:isCompare})
  }

  toggleAnswerExpiredModal(){
    this.setState({answerExpired : !this.state.answerExpired})
  }

  componentWillUnmount() {
    if (this.countdown) {
      clearInterval(this.countdown);
      const timeRemaining = this.state.timeRemaining;
      if (this.props.userAssessment) {
        const subtestId = this.props.match.params.subTestSetId;
        const subtest = this.props.userAssessment.assessmentSubtests[subtestId];
        const userAssessmentId = this.props.match.params.userAssessmentId;
        const path = `destructuredSubtests.${subtestId}.timeRemaining`;
        db.collection("userAssessments")
          .doc(userAssessmentId)
          .update({
            [path]: timeRemaining
          })
          .catch(err => console.log(err));
      }
    }
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    window.removeEventListener('keydown', this.handleKeyPress, false)
  }

  render() {
    console.log("resport",this.props.state)
    const { assessmentInitializingError, manageEducatorsError, compareGuaYear, licenses} = this.props;

    const subtestId = this.props.match.params.subTestSetId;
    const testUser = this.props.user || this.state.user;
    let test1 = this.props.state.assessment.currentAssismentName;
    let test2 = this.props.state.assessment.compareAssismentName;
    let groupUA = null;
    let groupUACompare = null;
    let assessmentId;
    let qs = {};
    let selectedGroupUA = this.props.match.params.userAssessmentId
      ? this.props.match.params.userAssessmentId
      : "";
    let selectedStudent = "";
    let isGroup;
  
    if (this.props.location.search) {
      qs = queryString.parse(this.props.location.search);
      isGroup = qs.g;
    }

    let year = qs.y ? qs.y : getSchoolYear().year
    console.log("groupUas",this.props.groupUAs)
    if (
      testUser.role !== "Student" &&
      this.props.groupUAs &&
      this.props.groupUAs[this.props.match.params.userAssessmentId]
    ) {
      assessmentId = qs.a;
      groupUA = this.props.groupUAs[selectedGroupUA];
      if (has(groupUA, year)) {
        groupUA = groupUA[year][this.props.currentAssessmentId ? this.props.currentAssessmentId : assessmentId];
      } else {
        groupUA = null;
      }
      //this.props.groupUAs[selectedGroupUA][selectedYear ? selectedYear : getSchoolYear().year][assessmentId];
    }

    if (
      testUser.role !== "Student" &&
      this.props.groupUAs &&
      this.props.groupUAs[this.props.match.params.userAssessmentId]
    ) {

      groupUACompare = this.props.groupUAs[selectedGroupUA];
      if (this.props.compareAssessmentId && has(groupUACompare, `${compareGuaYear}`)) {
        groupUACompare = this.props.groupUAs[selectedGroupUA][compareGuaYear][this.props.compareAssessmentId]
      } else {
        groupUACompare = null;
      }
    }



    const { districts, schools, educators, classes, students } = this.props;
    const groupData = {
      districts,
      schools,
      educators,
      classes,
      students
    };

    if (qs.s) {
      selectedStudent = qs.s;
    }

    let activeItem = this.props.activeItem;
    // bypasses getting active item from store if already have items and passages
    if (
      this.props.items &&
      qs.item !== "overview" &&
      qs.item !== "results" &&
      testUser.role !== "Student" &&
      groupUA &&
      this.props.passages
    ) {
      const activeItemId =
        groupUA.destructuredSubtests[subtestId].items[qs.item - 1];
      activeItem = this.props.items[activeItemId];
      if (activeItem) {
        if (activeItem.passageId && !activeItem.passage) {
          activeItem.passage = this.props.passages[activeItem.passageId].text;
        }
      }
    } else if (
      this.props.items &&
      qs.item !== "overview" &&
      qs.item !== "results" &&
      this.props.userAssessment &&
      this.props.passages
    ) {
      const activeItemId = this.props.userAssessment.destructuredSubtests[
        subtestId
      ].items[qs.item - 1];
      activeItem = this.props.items[activeItemId];
      if (activeItem) {
        if (activeItem.passageId && !activeItem.passage) {
          activeItem.passage = this.props.passages[activeItem.passageId] && this.props.passages[activeItem.passageId].text
        }
      }
    }
    console.log("12345",this.props.userAssessment)
    // this fixed the information coming in correctly, but somehow isn't fixing the flash!!!
    const loadingError = !!(Object.keys(assessmentInitializingError).length || Object.keys(manageEducatorsError).length);
    return (licenses.fetchingLicenses?<BeatLoader />:(isLicensed(
      queryString.parse(this.props.location.search).a
        ? queryString.parse(this.props.location.search).a
        : this.props.userAssessment &&
            this.props.userAssessment.assessmentSetId,
      this.props.userLicenses
    ) ? (
      <AssessmentTesting
        userAssessment={this.props.userAssessment}
        routeParams={this.props.match.params}
        inTest={this.props.inTest}
        search={this.props.location.search}
        setInTest={this.props.setInTest}
        activeItem={activeItem}
        selectAnswer={this.props.setSelectedAnswer}
        selectedAnswer={this.props.selectedAnswer}
        handleSubmitActivity={this.handleSubmitActivity}
        handleSubmitSubtest={this.handleSubmitSubtest}
        handleQuickNav={this.handleQuickNav}
        openTest={this.openTest}
        groupUAs={this.props.groupUAs}
        selectedGroupUA={selectedGroupUA}
        groupUA={groupUA}
        user={testUser}
        assessmentId={assessmentId}
        subtestId={subtestId}
        items={this.props.items}
        nodes={this.props.nodes}
        passages={this.props.passages}
        search={this.props.location.search}
        groupData={groupData}
        selectGroupUA={this.selectGroupUA}
        selectStudent={this.selectStudent}
        selectedStudent={selectedStudent}
        isGroup={isGroup}
        navTo={this.navTo}
        history={this.props.history}
        loadingError={loadingError}
        isFetchingGroupUAs={this.props.isFetchingGroupUAs}
        aFetchingAllItems={this.props.aFetchingAllItems}
        aFetchingAllPassages={this.props.aFetchingAllPassages}
        year={year ? year : getSchoolYear().year}
        updatingGUA={this.state.updatingGUA}
        userLicenses={this.props.userLicenses}
        previousTest={year == getSchoolYear().year ? true : false}
        toggleAnswerExpired={this.toggleAnswerExpiredModal}
        answerSelectedExpired={this.state.answerExpired}
        licenseExpired={isLicenseExpired(
          this.props.user.role,
          queryString.parse(this.props.location.search).a
            ? queryString.parse(this.props.location.search).a
            : this.props.userAssessment &&
                this.props.userAssessment.assessmentSetId,
          this.props.userLicenses
        )}
        currentAssessmentId = {this.props.currentAssessmentId}
        compareAssessmentId = {this.props.compareAssessmentId}
        test1 = {test1}
        test2 = {test2}
        isCompare = {this.props.state.assessment.isCompare}
        isSwap = {this.props.state.assessment.isSwap}
        compareGuaYear={compareGuaYear}
        groupUACompare={groupUACompare}
        userAssessmentCompare={this.props.userAssessmentCompare}
      />
    ) : (
      <LicenseDenied />
    ))) 
  }
}

export default connect(
  state => ({
    userAssessment: state.assessment.userAssessment,
    userAssessmentCompare: state.assessment.compareAssismentData,
    state : state ,
    currentAssessmentId : state.assessment.currentAssismentId,
    compareAssessmentId : state.assessment.compareAssismentId,
    inTest : state.assessment.inTest,
    activeItem: state.assessment.activeItem,
    selectedAnswer: state.assessment.selectedAnswer,
    passages: state.assessment.passages,
    items: state.assessment.items,
    groupUAs: state.assessment.groupUAs,
    isFetchingGroupUAs: state.assessment.isFetchingGroupUAs,
    selectedGroupUA: state.assessment.selectedGroupUA,
    GUAFilter: state.assessment.GUAFilter,
    districts: state.manageEducators.districts,
    schools: state.manageEducators.schools,
    educators: state.manageEducators.educators,
    classes: state.manageEducators.classes,
    students: state.manageEducators.students,
    user: state.users.testUser,
    nodes: state.assessment.nodes,
    assessmentInitializingError: state.assessment.assessmentInitializingError,
    manageEducatorsError: state.manageEducators.error,
    aFetchingAllItems: state.assessment.isFetchingAllItems,
    aFetchingAllPassages: state.assessment.isFetchingAllPassages,
    userLicenses : state.licenses.userlicenses,
    licenses:state.licenses,
    compareGuaYear: state.assessment.compareGuaYear,
    assessmentIndicator: state.assessmentIndicator
  }),
  dispatch =>
    bindActionCreators(
      { ...assessmentActionCreators, ...manageEducatorsActionCreators, setIndicator },
      dispatch
    )
)(AssessmentTestingContainer);


// WEBPACK FOOTER //
// ./src/containers/Assessment/AssessmentTestingContainer.js